<template>
  <div class="login-form login-forgot">
    <form
        class="form"
        novalidate="novalidate"
        id="kt_login_forgot_form"
    >
      <div class="pb-13 pt-lg-0 pt-5">
        <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
          {{ this.title }}
        </h3>
        <p class="text-muted font-weight-bold font-size-h4">
          {{ this.subTitle }}
        </p>
      </div>
      <div class="form-group">
        <input
            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
            type="email"
            placeholder="Email"
            name="email"
            autocomplete="off"
            v-model="form.email"
        />
      </div>
      <div class="form-group d-flex flex-wrap pb-lg-0">
        <button
            type="submit"
            id="kt_login_forgot_submit"
            ref="kt_login_forgot_submit"
            class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
        >
          {{ $t('common.submit') }}
        </button>
        <button
            v-if="hasCancelListener"
            type="button"
            id="kt_login_forgot_cancel"
            class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
            @click="$emit('showForm', 'signin1')"
        >
          {{ $t('common.cancel') }}
        </button>

        <div
            role="alert"
            class="alert fade alert-success show"
            v-for="(success, i) in successes" :key="i"
        >
          <div class="alert-text">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="dismissSuccess(i)">
              <span aria-hidden="true">&times;</span>
            </button>
            {{ success.message }}
          </div>
        </div>

      </div>
    </form>
  </div>
</template>

<script>
import Api from "../../core/services/api.service";
import KTUtil from "@/assets/js/components/util";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import Swal from "sweetalert2";

export default {
  name: "forgotForm",
  props: {
    title: String,
    subTitle: String,
  },
  data() {
    return {
      successes: [],
      form: {
        email: "",
      },
    }
  },
  computed: {
    hasCancelListener() {
      return this.$listeners && this.$listeners.showForm;
    }
  },
  mounted() {
    const forgot_form = KTUtil.getById("kt_login_forgot_form");

    this.fv = formValidation(forgot_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: this.$i18n.t('login.emailRequired'),
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv.on("core.form.valid", () => {
      const email = this.form.email;

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_forgot_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      Api.post('/forgot_password/', { email: email })
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          this.successes.push({ message: this.$i18n.t('login.forgotSuccess') });
        }
      })
      .catch(error => {
        console.log(error);
        Swal.fire({
          title: "",
          text: this.$i18n.t('common.errorOccurred'),
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      })
      .finally(() => {
        submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
        );
      });
    });

    this.fv.on("core.form.invalid", () => {
      Swal.fire({
        title: "",
        text: this.$i18n.t('login.incorrectData'),
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false,
      });
    });
  },
  methods: {
    dismissSuccess(index) {
      this.successes.splice(index, 1);
    }
  }
}
</script>
